// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "code/chunk-" + {"64":"subapps/onboarding","266":"subapps/kb","757":"subapps/chat","825":"subapps/settings"}[chunkId] + "." + {"64":"90b7de627071d79baf22","266":"24a0e4175d577a320300","757":"d0b04cff777b1978f511","825":"12435e795f0be7b5c418"}[chunkId] + ".css";
};